import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../lib/axios";
import { toast } from "react-toastify";

export const createMedia = createAsyncThunk(
  "media/createMedia",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await toast.promise(
        api.post("/api/createMedia", payload),
        {
          pending: "Creating media...",
          success: "Media created successfully!",
          error: "Failed to create media.",
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const createTemplate = createAsyncThunk(
  "templates/createTemplate",
  async ({ payload, projectId }, { rejectWithValue }) => {
    try {
      const response = await toast.promise(
        api.post("/api/createTemplate", {
          ...payload,
          projectId,
        }),
        {
          pending: "Creating template...",
          success: "Template created successfully!",
          error: "Failed to create template.",
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const editTemplate = createAsyncThunk(
  "templates/editTemplate",
  async ({ id, payload, projectId }, { rejectWithValue }) => {
    try {
      const response = await toast.promise(
        api.post(`/api/editTemplate/${id}`, { ...payload, projectId }),
        {
          pending: "Updating template...",
          success: "Template updated successfully!",
          error: "Failed to update template.",
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const fetchTemplates = createAsyncThunk(
  "templates/fetchTemplates",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await api.get("/api/templates", {
        params: projectId ? { projectId } : {},
      });
      return response.data;
    } catch (error) {
      console.error(
        "fetchTemplates error:",
        error?.response?.status,
        error?.response?.data || error?.message
      );
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "templates/deleteTemplate",
  async ({ id, name, projectId }, { rejectWithValue }) => {
    try {
      await toast.promise(
        api.delete(`/api/deleteTemplate`, { params: { id, name, projectId } }),
        {
          pending: "Deleting template...",
          success: "Template deleted successfully!",
          error: {
            render({ data }) {
              return (
                data.response?.data?.message || "Failed to delete template."
              );
            },
          },
        }
      );
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
